import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("wbz_admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Resolve an image URL — if relative (starts with /), prefix the backend URL so
// it works on both preview and production environments.
export const imgUrl = (url) => {
  if (!url) return url;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/")) return `${BACKEND_URL}${url}`;
  return url;
};

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_78c80ddc-5060-4a74-9515-ac877b107e9b/artifacts/1zk8ubkg_IMG_1817.jpeg";
